<template>
  <div>
    <div>
      <px-view-header title="Dashboard"
                      title-class="font-weight-bold"
                      :breadcrumbs="breadcrumbs"/>
      <div>
        <v-row>
          <v-col cols="12" class="text-right">
            <px-metabase-dashboard-header />
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="metabase-container" v-if="signedUrl">
      <iframe
        class="metabase-iframe"
        :src="signedUrl"
      ></iframe>
    </div>
  </div>

</template>

<script>
import MetabaseService from '@/modules/metabase/metabase-service';
import { mapGetters } from 'vuex';
import MetabaseDashboardHeader from '@/modules/metabase/MetabaseDashboardHeader.vue';

export default {
  data() {
    return {
      signedUrl: null,
      empresas: [],
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Dashboard' },
      ],
    };
  },
  computed: {
    ...mapGetters('metabaseDashboard', ['filtersState', 'empresa', 'produto', 'grupo', 'centroCusto', 'projeto', 'fornecedor', 'responsavel', 'solicitante', 'tipoProduto']),
  },
  watch: {
    filtersState: {
      handler() {
        this.getSignedUrl();
      },
      deep: true,
    },
  },
  methods: {
    getSignedUrl() {
      MetabaseService.getMetabaseDashboard({
        i_compradores: this.empresa ? [this.empresa.id] : [],
        i_produtos: this.produto ? this.produto.map(p => p.id) : [],
        i_grupos: this.grupo ? this.grupo.map(p => p.id) : [],
        i_centros_custos: this.centroCusto ? this.centroCusto.map(p => p.id) : [],
        i_projetos: this.projeto ? this.projeto.map(p => p.id) : [],
        i_fornecedores: this.fornecedor ? this.fornecedor.map(p => p.id) : [],
        i_responsaveis: this.responsavel ? this.responsavel.map(p => p.id) : [],
        solicitantes: this.solicitante ? this.solicitante.map(p => p.id) : [],
        tipo_de_produto: this.tipoProduto ? [this.tipoProduto] : [],
      })
        .then(({ data }) => {
          this.signedUrl = data;
        });
    },
  },
  created() {
    this.getSignedUrl();
  },
  components: {
    pxMetabaseDashboardHeader: MetabaseDashboardHeader,
  },
};
</script>

<style scoped>
.metabase-container {
  height: 1vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 3080px;
}

.metabase-iframe {
  background-color: white;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
